import { updateIntercomSettings } from 'ggApp/modules/intercom/service';

function hotjarTrigger(data, newData) {
    const currentShop = newData.params.store;
    const modalName = newData.location.query.modal;
    const locationName = newData.location.pathname.split('/').pop();

    if (currentShop === 'de' || currentShop === 'usa') {
        switch (locationName) {
            case 'cart':
                hj('trigger', `cart-${currentShop}`);
                break;

            case 'address':
                hj('trigger', `address-${currentShop}`);
                break;

            case 'checkout':
            case 'plan':
                hj('trigger', `plan-${currentShop}`);
                hj('vpv', `plan-${currentShop}`);
                break;

            case 'payment':
                hj('trigger', `payment-${currentShop}`);
                hj('vpv', `pay-${currentShop}`);
                break;

            case 'summary':
                hj('trigger', `summary-${currentShop}`);
                hj('vpv', `pay-sum-${currentShop}`);
                break;

            default:
                break;
        }

        switch (modalName) {
            case 'login':
                hj('trigger', `cart-signin-${currentShop}`);
                hj('vpv', `plan-info-${currentShop}`);
                break;

            case 'signup':
                hj('trigger', `cart-signup-${currentShop}`);
                hj('vpv', `plan-info-${currentShop}`);
                break;

            case 'createAddress':
                hj('trigger', `create-address-${currentShop}`);
                break;

            case 'editAddress':
                hj('trigger', `edit-address-${currentShop}`);
                break;

            case 'createPayment':
                hj('trigger', `create-payment-${currentShop}`);
                break;

            default:
                break;
        }
    }
}

export const onRouteChange = () => (data, newData) => {
    if (window.hj) hotjarTrigger(data, newData);
    updateIntercomSettings();
};
